import { authFetch } from 'src/auth/utils';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { DoughnutDTO } from 'src/common/components/Dashboard/Types/DashboardApiTypes';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { ObjectValues } from 'src/common/tsHelpers';
import { envVariables } from 'src/common/utils/envVariables';
import { UsageDto } from 'src/common/utils/mapUsageDTOtoAreaChartData';

export const ACTIVE_IN_SESSION = {
  IN_SESSION: 'In Session',
  OUT_OF_SESSION: 'Out of Session',
} as const;

type ActiveInSession = ObjectValues<typeof ACTIVE_IN_SESSION>;

export const getActiveInSession = async (
  {
    accountRef,
  }: {
    accountRef: string;
  },
  signal?: AbortSignal,
) => {
  const response = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/session/state?accountRef=${accountRef}&rguFilter=1`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const responseJSON: DoughnutDTO<ActiveInSession> = await response.json();

  const data = responseJSON.data.reduce(
    (acc, entry) => {
      acc[entry.label] = entry.value;
      return acc;
    },
    {
      [ACTIVE_IN_SESSION.IN_SESSION]: 0,
      [ACTIVE_IN_SESSION.OUT_OF_SESSION]: 0,
    },
  );

  return {
    data,
    total: responseJSON.total,
  };
};

type GetSimUsageDataProps = {
  accountRef: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
};

export const getSimUsageData = async (
  { accountRef, chartType, usageType }: GetSimUsageDataProps,
  signal?: AbortSignal,
) => {
  const simUsageUsageResponse = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/usage-tracking/tariff-usage/sims/${accountRef}/daily/${chartType}/${usageType}/linechart`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const simUsageUsageDTO: UsageDto = await simUsageUsageResponse.json();

  return simUsageUsageDTO.chartData;
};
